import { Component, Inject, OnInit, } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
@Component({
  selector: 'app-alert-popup',
  templateUrl: './alert-popup.component.html',
  styleUrls: ['./alert-popup.component.scss']
})
export class AlertPopupComponent implements OnInit {

  public submitEnable: boolean = false;
  public extractEnable: boolean = false;
  public selectEnable: boolean = true;

  batchkey: string = null;
  constructor( public dialogRef: MatDialogRef<AlertPopupComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  onClickOk() {
    this.dialogRef.close('ok');
  }

}
